import React from 'react';
import SubNavbar from '../SubNavbar';
import LocalizedLink from 'components/LocalizedLink';
import classnames from 'classnames';
import { Translator } from 'Translator';
import { withRouter, RouteComponentProps } from 'react-router-dom';

const CSS = require('./MessagesSubNavbar.less');

function MessagesSubNavbar({ location }: RouteComponentProps) {
  return (
    <SubNavbar>
      <div className={CSS.Filters}>
        <h1 className={CSS.Title}>{Translator.translate('Navbar.Buttons.messages', {}, true, 'Messages')}</h1>
        <LocalizedLink
          className={classnames(CSS.FilterLink, { [CSS.FilterLinkHasValue]: location.pathname.includes('messages') })}
          to="/messages/"
        >
          Show all
        </LocalizedLink>
        <LocalizedLink
          className={classnames(CSS.FilterLink, { [CSS.FilterLinkHasValue]: location.pathname.includes('action') })}
          to="/action/"
        >
          {Translator.translate('UserEnvironment.Common.actionRequired', {}, true)}
        </LocalizedLink>
      </div>
    </SubNavbar>
  );
}

export default withRouter(MessagesSubNavbar);
